<template>
  <Slide anchor="team" title="Команда" linkable>
    <TeamMember
      v-for="(member, name) in team"
      :key="name"
      :member="member"
      :name="name"
    />
  </Slide>
</template>

<script>
  import Slide from './Slide';
  import TeamMember from './TeamMember';

  export default {
    name: 'Team',
    components: { TeamMember, Slide },

    data() {
      return {
        team: {
          'zotovmaxim': {
            realName: 'Максим Зотов',
            roles: [
              'Основатель',
              'CEO',
            ],
          },
          'mazter': {
            realName: 'Александр Владимиров',
            roles: [
              'Сооснователь',
              'Backend Developer',
            ],
          },
          'slavyanist': {
            name: 'slavyanist',
            realName: 'Вячеслав Арисов',
            roles: [
              'Сооснователь',
              'Frontend Developer',
            ],
          },
          'monster-king': {
            name: 'monster-king',
            realName: 'Дмитрий Король',
            roles: [
              'Lead Frontend Developer',
            ],
          },
        },
      };
    },
  };
</script>

<style lang="less" scoped>
  //
</style>

<style lang="less">
  @import (reference) '../shared.less';

  #team {
    .content {
      @media @vertical {
        flex-wrap: wrap;
      }

      @media @mobile-vertical {
        flex-direction: column;
        align-items: center;
      }
    }
  }
</style>
